import { configQuery, ipCountryQuery, setInterpolationParams, translate, updateInterpolationParams } from '@gig/magic-common';
import { magic } from '@gig/magic-sdk';
import { meta } from '../services/meta/meta.service.js';
import { getMetaTags } from './meta.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function calculateLoyaltyTier(level, tiers) {
  if (level < 0 || !tiers || tiers.length === 0) {
    return 0;
  }
  const tierIndex = tiers.findIndex((curr) => level >= curr.min && (curr.max === void 0 || level <= curr.max));
  return tierIndex > 0 ? tierIndex : 0;
}
function setMetaInformation() {
  getMetaTags().forEach(({ name, content }) => {
    meta.setDefaultTagInformation({
      name,
      content: translate(content)
    });
  });
  meta.setTitle(translate("meta.default.title"));
}
function initWakeLock() {
  if ("wakeLock" in navigator) {
    navigator.wakeLock.request("screen");
  }
}
function setUserInterpolationParams() {
  return __async(this, null, function* () {
    var _a;
    const user = magic.session.getUser();
    let userParams = {};
    if (user) {
      const userInterpolationParams = [
        "userName",
        "country",
        "currency",
        "email",
        "firstName",
        "lastName",
        "roles"
      ];
      userParams = userInterpolationParams.reduce((params, field) => __spreadProps(__spreadValues({}, params), {
        [field]: user[field] || field
      }), {});
    }
    const interpolationParams = yield configQuery("interpolationParams");
    const visitorParams = {
      country: (_a = yield ipCountryQuery()) != null ? _a : ""
    };
    setInterpolationParams(__spreadValues(__spreadValues({}, interpolationParams), Object.assign(visitorParams, userParams)));
  });
}
function setLoyaltyInterpolationParams(progress, level, points) {
  return __async(this, null, function* () {
    const loyaltyTiers = yield configQuery("loyalty.tiers");
    const loyaltyTierIndex = calculateLoyaltyTier(level, loyaltyTiers).toString();
    const loyaltyTier = translate(`loyalty.tiers.tier-${loyaltyTierIndex}`);
    updateInterpolationParams({
      loyaltyLevel: level.toString(),
      loyaltyBalance: points.toString(),
      loyaltyProgress: Math.round(progress).toString(),
      loyaltyTier
    });
  });
}

export { calculateLoyaltyTier, initWakeLock, setLoyaltyInterpolationParams, setMetaInformation, setUserInterpolationParams };
